import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "VoiceReminder": "Voice Reminder",
  "Detail": "Detail",
  "Export": "Export"
})
i18n.mergeLocaleMessage('zh', {
  "VoiceReminder": "语音播报",
  "Detail": "详情",
  "Export": "导出"
})
i18n.mergeLocaleMessage('mm', {
  "VoiceReminder": "အသံသတိပေးချက်",
  "Detail": "အသေးစိတ်",
  "Export": "ထုတ်မည်"
})
  